import { Button, Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";
import Container from "@mui/system/Container";
import Box from '@mui/material/Box';
import Poster from './Images/Poster.png';
import Link from '@mui/material/Link';
import Health from './Images/health.png';
import card_img_1 from './Images/Card_img_1.png';
import card_img_2 from './Images/Card_img_2.png';
import card_img_3 from './Images/Card_img_3.png';
import card_img_4 from './Images/Card_img_4.png';
import card_img_5 from './Images/Card_img_5.png';
import card_img_6 from './Images/Card_img_6.png';
import card_img_7 from './Images/Card_img_7.png';
import card_img_8 from './Images/Card_img_8.png';
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import { useNavigate } from "react-router";




const H1 = styled(Typography)((theme)=>({
fontFamily: 'Outfit',
fontStyle: "normal",
fontWeight: "600",
fontSize: "56px;",
lineHeight: "110%",
letterSpacing: "-0.01em;",
color: "#000000;"
}))


const H2 = styled(Typography)((theme)=>({
fontFamily: 'Outfit',
fontStyle: "normal",
fontWeight: "600",
fontSize: "40px",
lineHeight: "125%",
letterSpacing: "0.01em",
color: "#1A1824"

}))

const H3 = styled(Typography)(({theme})=>({
    fontFamily: 'Outfit',
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "24px",
    lineHeight: "150%",
    letterSpacing: "0.01em",
    color: "#1A1824"
}))

const H4 = styled(Typography)(({theme})=>({
    fontFamily: 'Outfit',
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "20px",
    lineHeight: "150%",
    letterSpacing: "0.01em",
    color: "#1A1824"
}))

const P = styled(Typography)(({theme})=>({
    fontFamily: 'Outfit',
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "150%",
    letterSpacing: "0.01em",
    color: "#1A1824"
}))

const Btn = styled(Button)(({theme})=>({
    padding: '5px 20px;',
    border: '1px solid #559A95;',
    borderRadius: '24px;',
    fontSize: '15px;'

}))

const card_data =[
    {
        card_img: card_img_1,
        card_title: 'Eat Service',
        card_description: 'Diet, Sugar, and Inflammation',
        card_link: 'Read More'
    },
    {
        card_img: card_img_2,
        card_title: 'Eat Service',
        card_description: 'I Was Critical of Anti-Vaxxers Until…',
        card_link: 'Read More'
    },
    {
        card_img: card_img_3,
        card_title: 'Eat Service',
        card_description: 'How to eat well and save money',
        card_link: 'Read More'
    },
    {
        card_img: card_img_4,
        card_title: 'Eat Service',
        card_description: 'Delicious Mini-Apple Pie in a Sourdough Crust',
        card_link: 'Read More'
    },
    
]

const card_data_2 =[
    {
        card_img: card_img_5,
        card_title: 'Eat Service',
        card_description: 'The secret to successful weight loss ',
        card_link: 'Read More'
    },
    {
        card_img: card_img_6,
        card_title: 'Eat Service',
        card_description: 'How to Feed the World: Is Meat',
        card_link: 'Read More'
    },
    {
        card_img: card_img_7,
        card_title: 'Eat Service',
        card_description: 'Sorella Is Casual Italian Bliss',
        card_link: 'Read More'
    }
    , {
        card_img: card_img_8,
        card_title: 'Eat Service',
        card_description: '3 Healthy Ingredients You May',
        card_link: 'Read More'
    }

]

function Header(){

    let navigate = useNavigate();
    return(
        <>
        <Box  sx={{
            margin:'20px',
            width:'98%',
            display:'flex',
            flexDirection:{xl:'row',lg:'row',md:'row',sm:'column',xs:'column'},
            justifyContent:{xl:'center',lg:'space-between',md:'space-between'},
            alignItems:{xl:'center',lg:'center',md:'center',sm:'start',xs:"start"},
            }}
        >
           <Box sx={{
                width:{xl:'40%',lg:'43%',md:'50%',sm:'98%',xs:'97%'},
                display:{xl:'flex',lg:'block'},
                flexDirection:"row",
                justifyContent:'end',
            }}>
                <H1 sx={{fontSize:{lg:'56px',md:'50px',sm:'30px',xs:'30px'}}}>All Food insights are <br></br> on our blog</H1>
           </Box>
           <Box sx={{width:{xl:'60%',lg:'57%',md:'49%',sm:'98%',xs:'97%'}}}>
            <P >Lorem Ipsum is simply dummy text of the printing and typesetting 
                industry. Lorem Ipsum has been, Lorem Ipsum is simply dummy
                 text of the printing and typesetting industry. Lorem Ipsum
                  has been,Lorem Ipsum is simply dummy text of
                 the printing and typesetting industry. Lorem Ipsum has been</P>
           </Box>

        </Box>

        <Box sx={{
            width:'98%',
            display:'flex',
            flexDirection:{xl:'row',lg:'row',md:'row',sm:'column',xs:'column'},
            justifyContent:{xl:'center',lg:'space-between'},
            // alignItmes:'center'
            margin:'20px',
            }} 
        >
            <Box sx={{mt:2,width:{xl:'50%',lg:'48%',md:'45%',sm:'100%',xs:'100%'}}}>
                <img src={Poster} width="100%"/>
                <P sx={{color:'#2B817B',fontSize:{lg:'20px',md:'20px',sm:'15px',xs:'15px',marginTop:5}}}>Eat Service</P>
                <H2 sx={{fontSize:{lg:'32px',md:'32px',sm:'20px',xs:'20px',marginTop:10}}}>Healthy Food Recommendations for ‘Interludes’ While at Home</H2>
                <P sx={{fontSize:'16px',mt:2}}>Lorem Ipsum is simply dummy text of the printing and typesetting industr...</P>
                <Link  onClick={()=> navigate('/DetailContent')}>Read More</Link>
            </Box>
            <Box sx={{width:{xl:'50%',lg:'48%',md:'52%',sm:'100%',xs:'100%'}}}>
                <Box sx={{mt:2,display:'flex',flexDirection:"column",width:'100%'}}>
                    
                    <Box sx={{
                        width:'100%',
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center',
                    }}>
                        <Box>
                            <img style={{width:'196px',height:'144px'}} src={Health} />
                        </Box>
                        <Box sx={{width:'100%',ml:'10px'}}>
                        <P sx={{fontSize:'16px',color:'#2B817B',}}>Health</P>
                        <H3 sx={{fontSize:{lg:'24px',md:'24px',sm:'18px',xs:'18px'}}}>The 5 Habits That Will Help You  Burn Fat Efficiently</H3>
                        <Link onClick={()=> navigate('/DetailContent')}>Read More</Link>
                        </Box>
                    </Box>


                    <Box sx={{
                        width:'100%',
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center',
                    }}>
                        <Box>
                            <img style={{width:'196px',height:'144px'}} src={Health} />
                        </Box>
                        <Box sx={{width:'100%',ml:'10px'}}>
                        <P sx={{fontSize:'16px',color:'#2B817B',}}>Health</P>
                        <H3 sx={{fontSize:{lg:'24px',md:'24px',sm:'18px',xs:'18px'}}}>The 5 Habits That Will Help You  Burn Fat Efficiently</H3>
                        <Link onClick={()=> navigate('/DetailContent')}>Read More</Link>
                        </Box>
                    </Box>



                    <Box sx={{
                        width:'100%',
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center',
                    }}>
                        <Box>
                            <img style={{width:'196px',height:'144px'}} src={Health} />
                        </Box>
                        <Box sx={{width:'100%',ml:'10px'}}>
                        <P sx={{fontSize:'16px',color:'#2B817B',}}>Health</P>
                        <H3 sx={{fontSize:{lg:'24px',md:'24px',sm:'18px',xs:'18px'}}}>The 5 Habits That Will Help You  Burn Fat Efficiently</H3>
                        <Link onClick={()=> navigate('/DetailContent')}>Read More</Link>
                        </Box>
                    </Box>



                    {/* <Box sx={{mt:2}}>
                        <img src={Health} />
                    </Box>
                    <Box>
                    <P sx={{fontSize:'16px',color:'#2B817B',}}>Food</P>
                    <H3 sx={{fontSize:{lg:'24px',md:'24px',sm:'18px',xs:'18px',marginLeft:10}}}>The Food Rules I Don’t Follow</H3>
                    <Link href="#">Read More</Link>
                    </Box>






                    <Box sx={{mt:2}}>
                        <img src={Health} />
                    </Box>
                    <Box>
                    <P sx={{fontSize:'16px',color:'#2B817B',}}> Italian Food</P>
                    <H3 sx={{fontSize:{lg:'24px',md:'24px',sm:'18px',xs:'18px',marginLeft:10}}}>Sorella Is Casual Italian Bliss in San Francisco</H3>
                    <Link href="#">Read More</Link>
                    </Box> */}





                </Box>
            </Box>
        </Box>

        </>
    )
}




function Food(){
    return(
        <>
        <center>
        <Box  sx={{
            mt:10,
            width:{xl:"40%",lg:"60%",md:'70%',sm:'90%',xs:'100%'},
            display:'flex',
            flexDirection:{xl:"row",lg:"row",md:"row",sm:"row",xs:"column"},
            justifyContent:'space-evenly'
        }}>

           <Btn sx={{backgroundColor:'#F0FAF9;'}}>All</Btn>
           <Btn sx={{color:'#9EA3AE'}}>Eat</Btn>
           <Btn sx={{color:'#9EA3AE'}}>Food Hacks</Btn>
           <Btn sx={{color:'#9EA3AE'}}>Food News</Btn>
           <Btn sx={{color:'#9EA3AE'}}>Promotions</Btn>
        </Box>
        
        </center>
        <Box sx={{mt:'30px',width:'100%'}}>
            <Grid container spacing={4}>

            
            {card_data.map((item,key)=>{
                return(
                    <>
                    <Grid item lg={3} md={3} sm={6} xs={12}>
                        <Card  sx={{width:'100%', height:{xl:'320px',lg:'320px',md:'350px',sm:'320px'}}}>
                        <CardMedia component="img"
                        image={item.card_img}
                        height='180px'
                        />
                        
                        <CardContent >
                            <P sx={{color:' #2B817B;',fontSize:'16px'}}>{item.card_title}</P>
                            <H4>{item.card_description}</H4>
                            <Link sx={{color:'#2B817B;',fontSize:'16px'}}>{item.card_link}</Link>
                        </CardContent>
                        </Card>
                    </Grid>
                    </>
                )
              
              
            })}
            </Grid>
        </Box>

        <Box sx={{mt:'30px',width:'100%'}}>
        <Grid container spacing={4}>
            {card_data_2.map((item,key)=>{
                return(
                    <>
                    <Grid item lg={3} md={3} sm={6} xs={12}>
                        <Card  sx={{width:'100%', height:{xl:'320px',lg:'320px',md:'350px',sm:'320px'}}}>
                        <CardMedia component="img"
                        image={item.card_img}
                        height='180px'
                        />
                        
                        <CardContent >
                            <P sx={{color:' #2B817B;',fontSize:'16px'}}>{item.card_title}</P>
                            <H4>{item.card_description}</H4>
                            <Link sx={{color:'#2B817B;',fontSize:'16px'}}>{item.card_link}</Link>
                        </CardContent>
                        </Card>
                    </Grid>
                    </>
                )
            
            
            })}
            </Grid>
        </Box>
        </>
    )
}

export {
    Header,
    Food
}